export default __webpack_public_path__ + "static/media/shoppinglist.c4b61a4f.JPG";